import { useQuery } from '@tanstack/react-query';
import { getGiftCardDetails } from '../../services/gift-cards';
import useUser from '../global/useUser';

function useGetGiftCard({
  giftCardId,
  enabled = true,
}: {
  giftCardId: string | null | undefined;
  enabled?: boolean;
}) {
  const { user } = useUser();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['gift-card', giftCardId, user?.business?.id],
    queryFn: async () => {
      const result = await getGiftCardDetails(giftCardId!);
      return result;
    },
    enabled: !!giftCardId && enabled,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetGiftCard;
